import { render, staticRenderFns } from "./SubscriberBlock.vue?vue&type=template&id=c971a988&scoped=true&"
import script from "./SubscriberBlock.vue?vue&type=script&lang=js&"
export * from "./SubscriberBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberBlock.vue?vue&type=style&index=0&id=c971a988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971a988",
  null
  
)

export default component.exports